// core version + navigation, pagination modules:
import Swiper from 'swiper'
import { $qsa, $qs } from '../../../src/js/utils/querySelector'
import { Navigation, Pagination, Autoplay, FreeMode } from 'swiper/modules'

function logosSwiper() {
    const swipers = $qsa("[data-name='swiper-logos-carousel']")

    swipers.forEach((swiper) => {
        console.info('logosCarousel')
        const slider = new Swiper(swiper, {
            modules: [Navigation, Pagination, Autoplay, FreeMode],
            loop: true,
            draggable: true,
            allowTouchMove: true,
            effect: 'slide',
            centeredSlides: true,

            // Updated settings to match OwlCarousel
            autoplay: {
                delay: 5000, // equivalent to autoplayTimeout:5000
                disableOnInteraction: false,
            },
            spaceBetween: 50, // equivalent to margin:0
            slidesPerView: 'auto', // equivalent to autoWidth:true

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // Remove pagination since dots:false in OwlCarousel
            pagination: false,

            // Remove breakpoints as they're not in the OwlCarousel config
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },
                1116: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
            },
        })
    })
}

export default logosSwiper
